/**
 * PoliticaPrivacidadPage — página pública (misma ruta/contenido que el shell WMS).
 * Ruta: `/politica-privacidad` (también bajo prefijo `/login-portal` en lab).
 * Sin auth ni handoff Tiger: solo contenido estático legal.
 */
import React from 'react';
import './PoliticaPrivacidadPage.css';

const PoliticaPrivacidadPage = () => {
  return (
    <div className="lp-privacy-page">
      <article className="lp-privacy-article">
        <header className="lp-privacy-header">
          <h1 className="lp-privacy-title">Politicas de Privacidad</h1>
          <p className="lp-privacy-lead">
            Tratamiento de datos personales en la Aplicacion WMS de JPH Lions.
          </p>
        </header>

        <div className="lp-privacy-body">
          <p>
            Para poder utilizar la Aplicacion de manera eficiente y segura, los Usuarios
            deberan aportar Datos Personales. Por eso se requiere que estos datos sean
            verdaderos y exactos. La Empresa es responsable de la base de datos a la que se
            incorporaran los Datos Personales que se ingresan mediante la Aplicacion. Dicha
            base se encontrara debidamente registrada conforme la legislacion vigente. Los
            Datos Personales que los Usuarios ingresan a la Aplicacion son totalmente
            confidenciales y la Empresa adoptara las medidas de seguridad a su alcance para
            proteger la privacidad de los mismos de conformidad con la Ley 25.326. Los Datos
            Personales se procesan y almacenan en servidores o medios magneticos que
            mantienen altos estandares de seguridad y proteccion tanto fisica como
            tecnologica.
          </p>

          <p>
            Todo Usuario tendra derecho a solicitar y obtener informacion sobre los Datos
            Personales que la Aplicacion tenga en su base, quedando la Empresa obligada a
            proporcionar la informacion solicitada dentro de los diez (10) dias corridos de
            haber sido intimada fehacientemente. Asimismo, los Usuarios podran requerir en
            cualquier momento la eliminacion, correccion o actualizacion de sus Datos
            Personales de las bases de datos o almacenamiento que posea la Empresa. En caso
            que los Datos Personales sean requeridos por via legal, administrativa o
            judicial correspondiente, la Empresa se vera compelida a revelar los mismos a la
            autoridad solicitante. En la medida que la legislacion y normas de procedimiento
            lo permitan, la Empresa informara a los Usuarios sobre estos requerimientos.
          </p>

          <p>
            Asimismo, todo Usuario y titular de los Datos Personales &quot;tiene la facultad
            de ejercer el derecho de acceso a los mismos en forma gratuita a intervalos no
            inferiores a seis meses, salvo que se acredite un interes legitimo al efecto
            conforme lo establecido en el articulo 14, inciso 3 de la Ley Nº 25.326. La
            Direccion Nacional de Proteccion de Datos Personales, que funciona en el ambito
            de la Agencia de Acceso a la Informacion Publica, Organo de Control de la Ley Nº
            25.326, tiene la atribucion de atender las denuncias y reclamos que se
            interpongan con relacion al incumplimiento de las normas sobre proteccion de
            datos personales.&quot;
          </p>

          <p>
            Todas las bases de datos personales de la Empresa vinculadas a la operacion de
            la Aplicacion se encontraran debidamente registradas en el Registro Nacional de
            Bases de Datos, dentro del marco de la Direccion Nacional de Proteccion de Datos
            Personales. La direccion web de dicho organismo es{' '}
            <a
              className="lp-privacy-link"
              href="http://www.jus.gob.ar/datos-personales/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://www.jus.gob.ar/datos-personales/
            </a>
            .
          </p>

          <p>
            Los Usuarios aceptan que sus Datos Personales puedan ser transferidos al
            extranjero con la finalidad (i) de mejorar la calidad, rapidez y eficiencia del
            procesamiento de Datos Personales y Transacciones por parte de una sociedad
            relacionada o controlada, controlante o sometida al control comun de la Empresa
            o por un tercero procesador independiente en los terminos del articulo 25 de la
            Ley 25.326; y/o; (ii) de procesar Transacciones con Usuarios que residen o
            tengan su domicilio fuera de la Republica Argentina o que involucren la venta de
            Entradas para un evento o espectaculo que tenga lugar en el extranjero.
          </p>
        </div>
      </article>
    </div>
  );
};

export default PoliticaPrivacidadPage;
